export namespace SlideEnums {
    export enum SlideType {
        Cover = 0,
        ReportSummary = 1,
        GoogleAnalyticsSummary = 24,
        SpendSummary = 2,
        ConversionsSummary = 3,
        ConversionsValueSummary = 25,
        CostPerConversionSummary = 4,
        ReturnOnAdSpendSummary = 26,
        ImpressionsSummary = 5,
        ClicksSummary = 6,
        CostPerClickSummary = 7,
        SpendTargets = 8,
        CpaTargets = 9,
        RoasTargets = 27,
        TopPerformingAds = 10,
        TopPerformingKeywords = 11,
        TopPerformingSegments = 12,
        AdTest = 13,
        AdCreative = 14,
        FeaturedKeywordBid = 15,
        FeaturedScheduleAdjustment = 16,
        FeaturedAgeBid = 17,
        FeaturedGenderBid = 18,
        FeaturedParentalStatusBid = 19,
        FeaturedLocationBid = 20,
        WorkSummary = 21,
        NextSteps = 22,
        Conclusion = 23,
    }

    export enum SlideCategory {
        Cover = 0,
        Summary = 1,
        PerformanceSummary = 2,
        Targets = 3,
        // Ads = 4,
        // Keywords = 5,
        // Segments = 6,
        TopPerformers = 4,
        FeaturedImprovements = 7,
        WorkSummary = 8,
        Conclusion = 9,
    }

    export enum SlideTypeName {
        Cover = 'Cover',
        ReportSummary = 'Google Ads Summary',
        GoogleAnalyticsSummary = 'Google Analytics Summary',
        SpendSummary = 'Spend Summary',
        ConversionsSummary = 'Conversions Summary',
        ConversionsValueSummary = 'Conversion Value Summary',
        CostPerConversionSummary = 'Cost Per Conversion Summary',
        ReturnOnAdSpendSummary = 'ROAS Summary',
        ImpressionsSummary = 'Impressions Summary',
        ClicksSummary = 'Clicks Summary',
        CostPerClickSummary = 'Cost Per Click Summary',
        SpendTargets = 'Spend Targets',
        CpaTargets = 'Cost Per Conversion Targets',
        RoasTargets = 'ROAS Targets',
        TopPerformingAds = 'Top Performing Ads',
        TopPerformingKeywords = 'Top Performing Keywords',
        TopPerformingSegments = 'Top Performing Segments',
        AdTest = 'Featured Ad Test',
        AdCreative = 'Featured Ad Creative',
        FeaturedKeywordBid = 'Featured Keyword Bid',
        FeaturedScheduleAdjustment = 'Featured Schedule Adjustment',
        FeaturedAgeBid = 'Featured Age Bid Adjustment',
        FeaturedGenderBid = 'Featured Gender Bid Adjustment',
        FeaturedParentalStatusBid = 'Featured Parent Bid Adjustment',
        FeaturedLocationBid = 'Featured Location Bid Adjustment',
        WorkSummary = 'Work Summary',
        NextSteps = 'Next Steps',
        Conclusion = 'Conclusion',
    }

    export enum SlideCategoryName {
        Cover = 'Cover',
        Summary = 'Summary',
        PerformanceSummary = 'Performance Summary',
        Targets = 'Targets',
        TopPerformers = 'Top Performers',
        FeaturedImprovements = 'Featured Changes',
        WorkSummary = 'Work Summary',
        Conclusion = 'Conclusion',
    }
}
